"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../../hooks");
var _CetComponentsProvider = require("../../../providers/CetComponentsProvider");
const useStyles = (isMobileView, shape) => {
  const {
    fontFamily,
    themeColors
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    pxToRem
  } = (0, _hooks.useStylesUtils)();
  const ccTimePickerStyle = (0, _react.useMemo)(() => {
    const shapeProps = () => {
      const borderRadius = shape === 'roundedRectangle' ? pxToRem(10) : pxToRem(25);
      return {
        borderRadius
      };
    };
    const ccTimePicker = (0, _css.css)({
      fontFamily: fontFamily,
      fontWeight: 'bold',
      display: 'inline-block',
      direction: 'rtl',
      padding: `${pxToRem(4)} ${pxToRem(8)}`,
      border: `1px solid ${themeColors?.general.border}`,
      ...shapeProps(),
      '> span': {
        margin: pxToRem(5),
        marginInlineEnd: 0,
        '&:nth-child(2)': {
          marginInlineStart: pxToRem(3),
          marginInlineEnd: pxToRem(3),
          fontSize: pxToRem(14)
        }
      }
    });

    // --- Mobile Only ---

    const ccTimePickerAnchorBtn = (0, _css.css)({
      width: 'inherit',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      alignContent: 'center',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      gap: pxToRem(10)
    });
    const ccTimePickerScrollSelectorContainer = (0, _css.css)({
      fontFamily: fontFamily,
      direction: 'rtl',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'stretch',
      height: pxToRem(160),
      position: 'relative',
      fontSize: pxToRem(20)
    });
    const ccTimePickerScrollSelectorMask = (0, _css.css)({
      pointerEvents: 'none',
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      '&::after': {
        content: '":"',
        fontSize: pxToRem(20),
        fontWeight: 700,
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)'
      }
    });
    return isMobileView ? {
      ccTimePicker,
      ccTimePickerAnchorBtn,
      ccTimePickerScrollSelectorContainer,
      ccTimePickerScrollSelectorMask
    } : {
      ccTimePicker
    };
  }, [fontFamily, pxToRem, themeColors?.general.border, isMobileView, shape]);
  return {
    'cc-TimePicker': ccTimePickerStyle.ccTimePicker,
    'cc-TimePicker__anchor-btn': ccTimePickerStyle.ccTimePickerAnchorBtn,
    'cc-TimePicker__scroll-selector-container': ccTimePickerStyle.ccTimePickerScrollSelectorContainer,
    'cc-TimePicker__scroll-selector-mask': ccTimePickerStyle.ccTimePickerScrollSelectorMask
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;